// JS / Listing / Products

import 'arrive'
import gsap from 'gsap'

import { ocNodeExists } from '../helpers/_node-exists'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger);

function ocScanAttrs() {

  const attrs = document.querySelector('.oc-attributes');

  const terms = attrs.dataset.terms;
  const array = terms.split('+');

  const filters = document.querySelector('.oc-filters');
  const options = filters.querySelectorAll('.oc-option');

  options.forEach( option => {

    if (option.classList.contains('oc-disable')) {
      option.classList.remove('oc-disable');
    }

  });

  options.forEach( option => {

    const term = option.dataset.option;

    if ( array.indexOf(term) == -1 ) {
      option.classList.add('oc-disable');
    }

  });

  attrs.remove();

}

function ocRequest(params, grid, method) {

  const json = JSON.stringify(params);
  const request = new XMLHttpRequest();
  const url = ajax_object.ajax_url;

  request.open('POST', url, true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

  request.onload = function() {

    if ( this.status >= 200 && this.status < 400 ) {

      if ( method == 'add' ) {

        grid.innerHTML += this.responseText;

      } else {

        grid.innerHTML = this.responseText;

      }

      const section = grid.closest('.oc-listing');
      const attrs = document.querySelector('.oc-attributes');
      const count = section.querySelector('.oc-count span');
      const max = attrs.dataset.max;

      count.innerHTML = attrs.dataset.count;

      grid.setAttribute('data-query-max', max);
      grid.setAttribute('data-query-count', attrs.dataset.count);

      ocScanAttrs();

      if ( params['paged'] < max ) {
        ocNextPage(params, grid);
      }

    }

  }

  request.onerror = function() {}
  request.send('action=oc_filters&json=' + json);

}

function ocNextPage(params, grid) {

  ScrollTrigger.create({

    trigger: grid,
    start: 'bottom 100%',
    duration: 0,
    toggleActions: 'play none none none',

    onEnter: () => {

      params['prev'] = params['paged'];
      params['paged'] = params['prev'] + 1;
      params['init'] = 0;

      ocRequest(params, grid, 'add');

    },

  });

}

document.arrive('.oc-listing-items', {existing: true}, function() {

  const listing = this;
  let params = {};

  const grid = listing.querySelector('.oc-grid');
  const query = listing.querySelector('.oc-query');
  const options = document.querySelectorAll('.oc-option-item');
  const modal = document.querySelector('.oc-modal-filters');
  const btnReset = modal.querySelector('.oc-btn-reset');

  params['prev'] = 0;
  params['init'] = 1;

  const attrs = [].filter.call(query.attributes, function(at) {
    return /^data-/.test(at.name);
  });

  attrs.forEach( attr => {

    let name = attr.name;
    let value = attr.value;

    name = name.replace(/data-query-/g,'');

    if (name == 'limit' || name == 'paged' ) {
      value = parseInt(value);
    }

    params[name] = value;

  });

  ocNextPage(params, grid);

  options.forEach( option => {

    const input = option.querySelector('input');

    input.onclick = () => {

      const tax = input.name;

      params['prev'] = 0;
      params['paged'] = 1;
      params['init'] = 1;

      if ( option.classList.contains('oc-active') ) {

        if ( tax == 'item-category' ) {

          params[tax] = params['filter'];

        } else {

          params[tax] = '';

        }

        input.checked = false;
        option.classList.remove('oc-active');

        ocRequest(params, grid, 'replace');

      } else {

        params[tax] = input.value;

        input.checked = true;
        option.classList.add('oc-active');

        ocRequest(params, grid, 'replace');

      }

    }

  });

  btnReset.onclick = () => {
    options.forEach( option => {

      const input = option.querySelector('input');
      const tax = input.name;

      if (input.checked == true) {

        input.checked = false;
        option.classList.remove('oc-active');
        params[tax] = '';

      }

    });

    ocRequest(params, grid, 'replace');

  }

});
